/* eslint-disable */
import axios from 'axios'
import store from '@/store'

const client = axios.create({
  baseURL: process.env.BASE_API_URL,
  json: true
})

var exec = {
  token: localStorage.getItem('user-token'),
  userId: localStorage.getItem('user-id'),
  execute (method, resource, data) {
    if (!this.token) {
      this.token = localStorage.getItem('user-token')
    }
    if (!this.userId) {
      this.userId = store.getters.userId
    }
    return client({
      method,
      url: resource,
      headers: {
        'Authorization': 'Bearer ' + this.token
      },
      data
    }).then( (req) => {
      return req.data
    })
  },
  userList (isOpen) {
    return this.execute('get', '/user_list?userid=' + this.userId + '&is_open=' + isOpen)
  },
  textAnalticsData () {
    return this.execute('get', '/text_analytics')
  },
  isValid (input) {
    return this.execute('post', '/validateuser', input)
  },
  saveChanges (fields) {
    return this.execute('post', '/update_items?userid=' + this.userId, fields)
  }
}

export {exec}



// WEBPACK FOOTER //
// ./src/api.js